import { ContasService } from "@/services/contas/contas.service";
import { ResponseUsuario } from "@/services/usuarios/usuarios.service";
import { useAuthStoreUser } from "@/stores/app/authUser";
import { ref, watch } from "vue";

export function UsuariosContaAtual() {
    const currentAccountUsers = ref<ResponseUsuario[]>([]);
    const authStore = useAuthStoreUser();
    watch(() => authStore.currentConta?.id, async (newId) => currentAccountUsers.value = newId ? await new ContasService().getUsuariosVinculados(newId): [], {immediate: true})
    return currentAccountUsers
}